import { toAbsolute } from 'SharedHelpers/toAbsolute';

/**
 * Extracts authors for JsonLD
 * @param {Array} authors Array of authors from middleware.
 * @param {string} siteUrl String site url for absolute path.
 * @param {string} siteName String site name for default author name.
 * @returns {Object}
 */
export function getAuthorsForJsonLd({ authors, siteUrl, siteName }) {
  let allAuthors = [];

  if (authors && authors.length) {
    allAuthors = authors.map(author => {
      const authorBio = author.shortBio && author.shortBio !== '' ? author.shortBio : author.bio;
      const strippedBio = authorBio ? authorBio.replace(/(<([^>]+)>)/gi, '') : '';

      return ({
        '@type': 'Person',
        name: author.name,
        image: (author.image && author.image.src && (
          author.image.width && author.image.height ? (
            {
              '@type': 'ImageObject',
              url: toAbsolute(author.image.src, siteUrl),
              height: author.image.height,
              width: author.image.width,
            }
          ) : toAbsolute(author.image.src, siteUrl)
        )) || undefined,
        jobTitle: author.jobTitle || undefined,
        description: strippedBio,
        url: author.url && toAbsolute(author.url, siteUrl),
        sameAs: (author.social && author.social.length >= 1 && author.social.map(singleSocial => singleSocial.url)) || undefined,
      });
    });
  }

  // If no Author, set default
  if (allAuthors.length === 0) {
    allAuthors = [{
      '@type': 'Person',
      name: siteName ? `${siteName} Staff` : 'Staff',
    }];
  }

  return allAuthors;
}
